// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$dharmaDeliveryAreaApiService = {
      dharma_delivery_area_api_url: `${process.env.VUE_APP_MEMBER_API_URL}/dharma-delivery-areas`,

      /**
       * 查詢
       * @param {*} param 
       * @returns 
       */
      async query(param = '') {
        const url = `${this.dharma_delivery_area_api_url}`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },

      /**
       * 透過 ID 查詢
       * @param {*} id 
       * @param {*} additional 
       * @returns 
       */
      async getById(id, additional = '') {
        const url = `${this.dharma_delivery_area_api_url}/${id}`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null
      }
    }
  }
}
